(function () {
  'use strict';

  function hazir(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  hazir(function () {
    var kok = document.querySelector('[data-yr-kok]');
    var modal = document.querySelector('[data-yr-modal]');
    if (!kok || !modal) return;

    var form = modal.querySelector('[data-yr-form]');
    var govde = modal.querySelector('[data-yr-govde]');
    var hata = modal.querySelector('[data-yr-hata]');
    var yildizKutu = modal.querySelector('[data-yr-yildiz]');
    var onizle = modal.querySelector('[data-yr-onizle]');
    var buyutKutu = document.querySelector('[data-yr-buyut-kutu]');
    var puan = 0;
    var siparis = null;
    var fotoVeri = null;

    /* --- daha fazla goster --- */
    var dahaBtn = kok.querySelector('[data-yr-daha]');
    if (dahaBtn) {
      dahaBtn.addEventListener('click', function () {
        var gizli = kok.querySelectorAll('[data-yr-gizli]');
        for (var i = 0; i < gizli.length; i++) gizli[i].hidden = false;
        dahaBtn.remove();
      });
    }

    /* --- fotograf buyutme --- */
    kok.addEventListener('click', function (e) {
      var img = e.target.closest('[data-yr-buyut]');
      if (!img || !buyutKutu) return;
      buyutKutu.querySelector('img').src = img.getAttribute('data-yr-buyut');
      buyutKutu.hidden = false;
    });
    if (buyutKutu) {
      buyutKutu.addEventListener('click', function () { buyutKutu.hidden = true; });
    }

    /* --- modal ac/kapat --- */
    function ac() {
      hataGizle();
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    }
    function kapat() {
      modal.hidden = true;
      document.documentElement.style.overflow = '';
    }
    var acBtn = kok.querySelector('[data-yr-ac]');
    if (acBtn) acBtn.addEventListener('click', ac);
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-yr-kapat]')) kapat();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) kapat();
    });

    /* --- yildiz secimi --- */
    function yildizCiz() {
      var btns = yildizKutu.querySelectorAll('button');
      for (var i = 0; i < btns.length; i++) {
        btns[i].className = (i < puan) ? 'dolu' : '';
      }
    }
    yildizKutu.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-p]');
      if (!b) return;
      puan = parseInt(b.getAttribute('data-p'), 10);
      yildizCiz();
    });

    /* --- fotograf secimi: tarayicida kucult --- */
    var fotoInput = form.querySelector('input[name="foto"]');
    fotoInput.addEventListener('change', function () {
      var f = fotoInput.files && fotoInput.files[0];
      fotoVeri = null;
      onizle.hidden = true;
      if (!f) return;
      if (!/^image\//.test(f.type)) { hataGoster('Lütfen bir fotoğraf seçin.'); fotoInput.value = ''; return; }
      var okuyucu = new FileReader();
      okuyucu.onload = function (ev) {
        var img = new Image();
        img.onload = function () {
          var enBuyuk = 1200;
          var o = Math.min(1, enBuyuk / Math.max(img.width, img.height));
          var w = Math.round(img.width * o);
          var h = Math.round(img.height * o);
          var c = document.createElement('canvas');
          c.width = w; c.height = h;
          c.getContext('2d').drawImage(img, 0, 0, w, h);
          fotoVeri = c.toDataURL('image/jpeg', 0.82);
          onizle.querySelector('img').src = fotoVeri;
          onizle.hidden = false;
        };
        img.src = ev.target.result;
      };
      okuyucu.readAsDataURL(f);
    });

    function hataGoster(m) { hata.textContent = m; hata.hidden = false; }
    function hataGizle() { hata.hidden = true; }

    /* --- gonderim --- */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      hataGizle();
      var d = {
        urun: kok.getAttribute('data-urun'),
        puan: puan,
        ad: form.ad.value.trim(),
        metin: form.metin.value.trim(),
        eposta: form.eposta.value.trim(),
        foto: fotoVeri,
        jeton: siparis ? new URLSearchParams(window.location.search).get('yorum') : null
      };
      if (!puan) return hataGoster('Yıldızlardan birine dokunarak puanınızı verebilirsiniz 🌸');
      if (!siparis && d.ad.length < 2) return hataGoster('Yorumun altında görünmesi için adınızı yazar mısınız?');
      if (d.metin.length < 15) return hataGoster('Birkaç kelime daha yazabilir misiniz? 🌸');
      if (!siparis && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(d.eposta)) return hataGoster('İndirim kodunuzu gönderebilmemiz için e-postanızı yazar mısınız? 🌸');

      var uc = kok.getAttribute('data-uc');
      if (!uc || uc.indexOf('http') !== 0) {
        /* Uc henuz yayinda degil: WhatsApp'a yonlendir */
        var mesaj = 'Merhaba, urun yorumu gondermek istiyorum.\n\n' +
          'Puan: ' + puan + '/5\n' +
          'Ad: ' + d.ad + (d.sehir ? ' (' + d.sehir + ')' : '') + '\n' +
          (d.aroma ? 'Aroma: ' + d.aroma + '\n' : '') +
          (d.baslik ? 'Baslik: ' + d.baslik + '\n' : '') +
          'Yorum: ' + d.metin + '\n' +
          'E-posta: ' + d.eposta +
          (d.siparis ? '\nSiparis: ' + d.siparis : '');
        window.open('https://wa.me/905824007282?text=' + encodeURIComponent(mesaj), '_blank');
        basarili(false);
        return;
      }
      var btn = form.querySelector('[data-yr-gonder]');
      btn.disabled = true;
      btn.textContent = 'Gönderiliyor…';

      fetch(uc, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(d)
      }).then(function (r) {
        return r.text();
      }).then(function (t) {
        if (t && t.indexOf('tamam') === -1) throw new Error(t);
        basarili(!!fotoVeri);
      }).catch(function () {
        btn.disabled = false;
        btn.textContent = 'Gönder';
        hataGoster('Gönderilemedi. İnternet bağlantınızı kontrol edip tekrar deneyin ya da WhatsApp’tan yazın: 0 850 XXX XX XX');
      });
    });


    /* --- kisiye ozel baglanti: ?yorum=JETON --- */
    var jeton = null;
    try {
      jeton = new URLSearchParams(window.location.search).get('yorum');
    } catch (e) { jeton = null; }

    if (jeton) {
      var uc0 = kok.getAttribute('data-uc');
      if (uc0 && uc0.indexOf('http') === 0) {
        fetch(uc0 + '?t=' + encodeURIComponent(jeton))
          .then(function (r) { return r.json(); })
          .then(function (s) {
            if (!s || !s.ok) return;
            siparis = s;
            var adAlan = form.ad.closest('.yr-alan');
            var epAlan = form.eposta.closest('.yr-alan');
            form.ad.value = s.ad || '';
            form.eposta.value = s.eposta || '';
            if (adAlan) adAlan.hidden = true;
            if (epAlan) epAlan.hidden = true;
            var kimlik = document.createElement('div');
            kimlik.className = 'yr-kimlik';
            kimlik.innerHTML = '<span class="yr-rozet">✓ Doğrulanmış alıcı</span> ' +
              '<b>' + (s.ad || '') + '</b>' + (s.sehir ? ' · ' + s.sehir : '') +
              (s.aroma ? ' · ' + s.aroma : '') + (s.siparis ? ' · ' + s.siparis : '') +
              '<button type="button" class="yr-kimlik-degis" data-yr-kimlik-degis>Bilgilerimi kendim yazayım</button>';
            form.insertBefore(kimlik, form.firstChild);
            kimlik.addEventListener('click', function (ev) {
              if (!ev.target.closest('[data-yr-kimlik-degis]')) return;
              siparis = null;
              if (adAlan) adAlan.hidden = false;
              if (epAlan) epAlan.hidden = false;
              kimlik.remove();
            });
            /* davet baglantisiyla gelen kisi icin formu dogrudan ac */
            ac();
          })
          .catch(function () {});
      }
    }

    function basarili(fotoVar) {
      govde.innerHTML =
        '<div class="yr-ok">' +
        '<div style="font-size:40px">💌</div>' +
        '<h3>Teşekkürler!</h3>' +
        '<p class="yr-alt">Yorumunuz bize ulaştı. Yayınlandığında <strong>' +
        (fotoVar ? '150 TL' : '100 TL') +
        ' indirim kodunuz</strong> e-postanıza gelecek 🌸</p>' +
        '<button type="button" class="yr-gonder" data-yr-kapat>Kapat</button>' +
        '</div>';
    }
  });
})();
